import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_RECIPIENTS_FIELD_MAX_COUNT,
  EMAIL_CREATION_FORM_RECIPIENTS_TOTAL_MAX_COUNT,
} from '../../EmailCreationForm.constants'

export function isOverLimitRecipients(values, mass) {
  if (mass) {
    return false
  }

  return (
    values[EMAIL_CREATION_FORM_FIELD_NAME_TO].length +
      values[EMAIL_CREATION_FORM_FIELD_NAME_CC].length +
      values[EMAIL_CREATION_FORM_FIELD_NAME_BCC].length >
    EMAIL_CREATION_FORM_RECIPIENTS_TOTAL_MAX_COUNT
  )
}

export function isToFieldLimit(value, mass = false) {
  if (mass) {
    return false
  }

  return value.length > EMAIL_CREATION_FORM_RECIPIENTS_FIELD_MAX_COUNT
}

export function isContainsFieldLimit(values, mass) {
  if (mass) {
    return false
  }

  return (
    isToFieldLimit(values[EMAIL_CREATION_FORM_FIELD_NAME_TO]) ||
    isToFieldLimit(values[EMAIL_CREATION_FORM_FIELD_NAME_CC]) ||
    isToFieldLimit(values[EMAIL_CREATION_FORM_FIELD_NAME_BCC])
  )
}
